import SmoothScroll from "smooth-scroll";
import TopBar from "./components/TopBar";
import Header from "./components/Header";
import Main from "./components/Main";
import Footer from "./components/Footer";
import Hero from "./components/Hero";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  return (
    <div>
      <TopBar />
      <Header />
      <Hero />
      <Main />
      <Footer />
    </div>
  );
};

export default App;
